import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { faArrowRight } from "@fortawesome/pro-regular-svg-icons";

import FormContainer from "@/pages/Public/components/FormContainer";
import { Icon } from "@/components";
import { trackQuestionnaireIntroStart, trackQuestionnaireIntroContinue } from "@/utils/analytics";

interface BusinessInfoIntroProps {
	onContinue: () => void;
}

export default function BusinessInfoIntro({ onContinue }: BusinessInfoIntroProps) {
	const { t } = useTranslation();
	const ts = (key: string) => t(`questionnaire.introduction.${key}`);

	// Track intro page view on mount
	useEffect(() => {
		trackQuestionnaireIntroStart();
	}, []);

	const handleContinue = () => {
		trackQuestionnaireIntroContinue();
		onContinue();
	};

	return (
		<div className="h-fit mt-24 mb-24 space-y-4 mx-auto max-w-[100%]">
			<FormContainer
				formContainerClassName="h-fit"
				handleSubmit={handleContinue}
				isLoading={false}
				showLogo={false}
				submitButtonText={
					<p className="text-[14px] text-white font-medium flex items-center justify-center gap-2">
						{ts("continue")}
						<Icon className="w-4 h-3 text-white" icon={faArrowRight} />
					</p>
				}
				submitButtonType="button"
				title={ts("title")}
			>
				<p className="text-[14px] text-primary-gray-lighter mb-2">{ts("text")}</p>
			</FormContainer>
		</div>
	);
}
